export default __webpack_public_path__ + "4b7cc8a0217fef39d11f5adfa4be249a.png";